// Returns an array of cookie names that are used for authentication and authorization.
// When `kaid` is passed, the result will contain `returning_login_<kaid>` if that cookie
// exists.  Otherwise, the result will contain all cookie names starting with `returning_login_`.
export const getAuthCookieNames = (
    kaid?: string | null,
): ReadonlyArray<string> => {
    const returningLoginCookieNames: Array<string> = [];
    for (const cookie of document.cookie.split(";")) {
        const [name, _] = cookie.trim().split("=");
        if (name.startsWith("returning_login_")) {
            returningLoginCookieNames.push(name);
        }
    }

    const cookieNames = [
        "fkey",
        "gae_b_id",
        "just_logged_out",
        "G_AUTHUSER_H",
        "KAAC",
        "KAAL",
        "KAAS",
    ];
    return kaid
        ? [...cookieNames, `returning_login_${kaid}`]
        : [...cookieNames, ...returningLoginCookieNames];
};
